// For reference only; use PaymentMethodSubtype whenever available
export enum PaymentMethodCode {
    ANDROID_PAY = '02,BCMP,AndroidPay',
    APPLE_PAY = '02,BCMP,ApplePay',
    CREDIT_CARD = '02,BCMP,CreditCard', // JCB, Master, Visa
    UNION_PAY = '03,BCMP,CreditCard',
    PPS = '01,PPSB,PPS',
    FPS = '04,BCFP,FPS', // 202309: from web api doc
}
